module.exports = __webpack_public_path__ + "img/logo_toyota.f7baa068.png";